 <template>
  <div class="CommunicationsSupporter">
    <div class="supporters">
      <div class="title text-center-s">
        COMUNICAÇÃO COM OS SUPPORTERS &nbsp;
        <Button v-if="!showNew" @click="showNew = true" layout="green-go"
          >NOVO COMUNICADO</Button
        >
        <Button v-if="showNew" @click="showNew = false" layout="red-go"
          >FECHAR</Button
        >
      </div>
      <div class="content column" v-if="showNew">
        <div class="sub row">
          <div class="grid-10">
            <i class="fa fa-pencil font-16" /> &nbsp; NOVO COMUNICADO
          </div>

          <div class="row justify-end grid-2">
            <i
              class="fa fa-times font-20 pointer text-red"
              title="Fechar"
              @click="showNew = false"
            />
          </div>
        </div>
        <div class="row wrap column-s align-center">
          <div class="grid-3 grid-12-s column section">
            <div class="label">DATA DE ENVIO</div>
            <div class="row align-center">
              <input
                class="input"
                type="datetime-local"
                v-model="form.dh_agendamento_envio"
              />
            </div>
          </div>
          <div class="column grid-8-g grid-11-m grid-12-s">
            <div class="label">CANAIS</div>
            <div class="row wrap column-s justify-space">
              <div class="row align-center">
                <input type="checkbox" v-model="form.canal_prioritario" />
                Canal Prioritário &nbsp;
                <i class="fa fa-question-circle font-13 tip">
                  <div>
                    <p>
                      Não selecionar canal prioritário, fará com que cada
                      supporter recebe a mensagem em todos os canais que ele
                      tiver habilitado.
                    </p>
                    <p>
                      Selecionar canal prioritário, fará com que cada supporter
                      receba apenas uma única mensagem, no canal habilitado que
                      tiver de maior prioridade, ou seja, de menor número.
                      <br /><br />

                      Exemplo:<br /><br />
                      => Contexto<br />
                      Canais disponíveis: Aplicativo como prioridade 1, Telegram
                      com prioridade 2, Slack com prioridade 3 e E-mail com
                      prioridade 4 <br />
                      Supporter 1: Possui canais Telegram, E-mail<br />
                      Supporter 2: Possui canais Aplicativo, Telegram e
                      E-mail<br />
                      Supporter 3: Possui apenas E-mail<br />
                      Supporter 4: Possui Todos os canais
                      <br /><br />

                      => Mensagem <br />
                      * Canais escolhidos: Aplicativo, Telegram e Slack<br /><br />
                      * Canal prioritário selecionado:<br />
                      - Supporter 1: Recebe apenas uma mensagem no canal
                      Telegram<br />
                      - Supporter 2: Recebe apenas uma mensagem no canal
                      Aplicativo<br />
                      - Supporter 3: Não recebe nenhuma mensagem <br />-
                      Supporter 4: Recebe apenas uma mensagem no canal
                      Aplicativo <br /><br />

                      * Canal prioritário não selecionado: <br />
                      - Supporter 1: Recebe a mensagem no canal Telegram<br />
                      - Supporter 2: Recebe a mensagem nos canais Aplicativo e
                      Telegram<br />
                      - Supporter 3: Não recebe nenhuma mensagem <br />
                      - Supporter 4: Recebe a mensagem nos canais Aplicativo,
                      Telegram e Slack
                    </p>
                  </div>
                </i>
              </div>

              <div
                class="row align-center"
                v-for="(canal, prop) of canais"
                :key="canal + prop"
                @change="loadStats()"
              >
                <input type="checkbox" v-model="canais[prop].check" /> &nbsp;
                <div class="column card grid-12-s">
                  <div class="name">
                    {{ canal.nome }}
                  </div>
                  <span class="font-12">
                    Prioridade: <b>{{ canal.prioridade }}</b></span
                  >
                  <span class="font-12" v-if="stats[prop]">
                    Custo: <b>{{ stats[prop].custo }}</b
                    ><br />
                    Doutores: <b>{{ stats[prop].doutores }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row column-s grid-12 title-msg">
            <div class="grid-12-s" :class="subject ? 'grid-6' : 'grid-12'">
              <div class="label">TÍTULO</div>
              <input
                placeholder="Título"
                type="text"
                class="input"
                v-model="form.titulo"
              />
            </div>
            <div class="grid-6 grid-12-s subject" v-if="subject">
              <div class="label">ASSUNTO</div>
              <input
                type="text"
                placeholder="Assunto"
                class="input"
                v-model="form.assunto"
              />
            </div>
          </div>

          <div class="grid-12 column msg">
            <div class="label">MENSAGEM</div>
            <textarea
              class="textarea"
              v-model="form.mensagem"
              placeholder="Mensagem"
            ></textarea>
          </div>
          <div class="grid-12 buttons">
            <Button layout="green-go" :loader="loaderCreate" @click="createComm"
              >Criar</Button
            >
          </div>
        </div>
      </div>
      <div class="filters column">
        <div class="label">FILTROS</div>

        <div class="row column-s wrap justify-space">
          <div class="row align-center">
            <input
              type="checkbox"
              v-model="filter.canal_prioritario"
              @click="gofilter()"
            />
            Canal Prioritário
          </div>
          <div
            class="row align-center"
            v-for="(canal, prop) of canais"
            :key="canal + prop"
          >
            <input
              type="checkbox"
              v-model="canaisFilter[prop]"
              @click="gofilter(prop)"
            />
            {{ canal.nome }}
          </div>

          <div class="row align-center">
            <input
              type="checkbox"
              v-model="filter.processado"
              @click="gofilter()"
            />
            Processado?
          </div>
          <div class="row column-s align-center">
            <br />
            <div class="grid-7 grid-12-s">Data de envio:</div>
            <input
              class="input"
              type="datetime-local"
              v-model="filter.dh_agendamento_envio"
              @blur="gofilter()"
            />
          </div>
        </div>
      </div>

      <div v-if="loader" class="job-loader column align-center justify-center">
        <br /><br /><br />
        <Loader />
      </div>
      <div class="row wrap" v-if="communications && communications.length > 0">
        <Card
          v-for="(comm, index) in communications"
          :key="'card' + index"
          :id="'card-' + comm.id"
          :comm="comm"
          @deleteComm="(id) => deleteComm(id)"
        />
      </div>
      <div class="text-center" v-if="!loader && communications && communications.length == 0">
        <br /><br /><b> NENHUM COMUNICADO ENCONTRADO</b>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Card from "@/components/CardCommSupporter.vue";
import Loader from "@/components/Loader";
export default {
  name: "Comm",
  components: { Button, Card, Loader },
  data() {
    return {
      loader: true,
      loaderCreate: false,
      showNew: false,
      canais: {},
      communications: [],
      form: {
        canais: [],
        canal_prioritario: false,
        assunto: "",
        mensagem: "",
        dh_agendamento_envio: "",
      },
      canaisFilter: {},
      filter: { canais: [] },
      subject: false,
      stats: {},
    };
  },
  beforeMount() {
    this.loadList();
    this.LIST_CANAIS().then((r) => (this.canais = r ? r.data : {}));
  },
  methods: {
    ...mapActions("admin", [
      "LIST_COMM_SUPPORTER",
      "CREATE_COMM_SUPPORTER",
      "LIST_CANAIS",
      "STATS_COMMUNICATION",
    ]),
    channel() {
      let canais = [];
      for (let i in this.canais) this.canais[i].check && canais.push(i);

      return canais;
    },
    loadStats() {
      let canais = [];
      this.subject = false;

      for (let canal in this.canais) {
        if (this.canais[canal].requer_assunto && this.canais[canal].check)
          this.subject = true;
        if (this.canais[canal].check) canais.push(canal);
      }

      if (!this.subject) this.form.assunto = "";

      this.STATS_COMMUNICATION({
        canais: canais,
        canal_prioritario: this.form.canal_prioritario,
      }).then((r) => (this.stats = r && r.data ? r.data : this.stats));
    },
    loadList() {
      this.loader = true;
      /*  let date = new Date();
      let datePass = new Date(date.setDate(date.getDay() - 7))
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      this.filter.dh_agendamento_envio_inicio = datePass;
      this.filter.dh_agendamento_envio = datePass;

      this.filter.dh_agendamento_envio_fim = new Date(
        date.setDate(date.getDay() + 7)
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " "); */
      if (this.filter.dh_agendamento_envio)
        this.filter.dh_agendamento_envio =
          this.filter.dh_agendamento_envio.replace("T", " ");

      this.LIST_COMM_SUPPORTER(this.filter).then((r) => {
        this.communications = r ? r.data : [];
        this.loader = false;
      });
    },
    deleteComm(id) {
      document.getElementById("card-" + id).remove();
    },
    gofilter(canal) {
      if (canal && !this.canaisFilter[canal]) this.filter.canais.push(canal);

      if (canal && this.canaisFilter[canal])
        this.filter.canais.splice(this.filter.canais.indexOf(canal), 1);
      var self = this;
      setTimeout(function () {
        self.loadList();
      }, 500);
    },
    createComm() {
      this.loaderCreate = true;
      for (let i in this.canais)
        this.canais[i].check && this.form.canais.push(i);
      this.form.dh_agendamento_envio = this.form.dh_agendamento_envio.replace(
        "T",
        " "
      );

      this.CREATE_COMM_SUPPORTER(this.form).then(() => {
        this.loaderCreate = false;
        for (let i in this.canais) this.canais[i].check = false;
        this.form = {
          canais: [],
          canal_prioritario: false,
          assunto: "",
          mensagem: "",
          dh_agendamento_envio: "",
          ciente_custos: false,
        };

        this.loadList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.CommunicationsSupporter {
  color: $font-color;
  margin-top: 1rem;
  padding: 10px;
  .supporters {
    padding: 25px 20px;
    background: #fff;
    box-shadow: $shadow;
    border-radius: 23px;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: $gray-9;
      padding-bottom: 5px;
    }
    .content {
      margin-top: 25px;
      padding: 15px;
      background: $gray-8;
      border-radius: 7px;
      box-shadow: $shadow;
    }
    .sub {
      border-radius: 5px;
      font-size: 16px;
      color: #bbb;
      font-weight: bold;
    }
    .label {
      font-weight: bold;
      color: $gray-9;
      font-size: 12px;
      margin: 10px 0px;

      @media (max-width: $small) {
        margin-top: 30px;
      }
    }
    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .section {
      margin-top: 20px;
      @media (min-width: $small) {
        margin-right: 70px;
      }
    }
    .msg {
      margin-top: 25px;
    }
    .title-msg {
      margin-top: 20px;
      .grid-12 {
        @media (min-width: $small) {
          width: 99%;
        }
      }
      input {
        @media (max-width: $small) {
          width: 94%;
        }
      }
    }
    .subject {
      @media (min-width: $small) {
        margin: 0 20px;
      }
    }
    .buttons {
      margin-top: 10px;
    }
    .filters {
      margin-top: 25px;
      /*  border: 1px solid #ddd; */
      background: #f1f1f1;
      border-radius: 7px;
      padding: 10px 12px;
      padding-top: 5px;
      box-shadow: $shadow;
    }
    .card {
      background: #fff;
      padding: 12px;
      border-radius: 4px;
      box-shadow: $shadow;
      @media (max-width: $small) {
        margin-top: 35px;
      }
      .name {
        border-bottom: 1px solid $client-2;
        padding: 0px 3px;
        padding-bottom: 4px;
        margin-bottom: 4px;
      }
    }
  }
}
</style>